import { render, staticRenderFns } from "./Torta.vue?vue&type=template&id=3172d096&scoped=true&"
import script from "./Torta.vue?vue&type=script&lang=js&"
export * from "./Torta.vue?vue&type=script&lang=js&"
import style0 from "./Torta.vue?vue&type=style&index=0&id=3172d096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3172d096",
  null
  
)

export default component.exports